import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { rangoDe } from './rangos'


// One row of controls: presets, or a custom range.
export default function Periodo({ valor, onChange, inicial = '30' }) {
  const { t } = useTranslation('operations')
  const [clave, setClave] = useState(inicial)
  const elegir = (k) => { setClave(k); if (k !== 'otro') onChange(rangoDe(k)) }
  return (
    <div className="inline-flex flex-wrap items-center gap-2">
      <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5">
        {['semana', '30', 'mes', '90', 'otro'].map(k => (
          <button key={k} type="button" onClick={() => elegir(k)}
            className={`px-3 py-1 rounded-md text-sm font-medium ${clave === k ? 'bg-gray-900 text-white' : 'text-gray-500 hover:text-gray-900'}`}>
            {t(`ot.periodo.${k}`)}
          </button>
        ))}
      </div>
      {clave === 'otro' && (
        <span className="inline-flex items-center gap-1.5 text-sm text-gray-600">
          <input type="date" value={valor.desde} max={valor.hasta} onChange={e => onChange({ ...valor, desde: e.target.value })}
            className="border border-gray-200 rounded-md px-2 py-1 text-sm bg-white" />
          –
          <input type="date" value={valor.hasta} min={valor.desde} onChange={e => onChange({ ...valor, hasta: e.target.value })}
            className="border border-gray-200 rounded-md px-2 py-1 text-sm bg-white" />
        </span>
      )}
    </div>
  )
}
